<template>
    <div class="flex flex-col h-screen bg-gray-100">
        <!-- Password Recovery Modal -->
        <PasswordRecoveryModal
            v-if="showRecoveryModal"
            @close="showRecoveryModal = false"
            @success="showRecoveryModal = false"
        />
        <div
            style="background-image: url(/assets/images/bg/fpv-bg.png); background-repeat: no-repeat; background-size: cover;"
            class="grid h-full place-items-center my-20 sm:my-auto">
            <div class="w-11/12 p-12 sm:w-8/12 md:w-6/12 lg:w-4/12 2xl:w-3/12 
                px-6 py-10 sm:px-10 sm:py-6 
                bg-white rounded-lg shadow-md lg:shadow-lg
                lg:ml-auto lg:mr-20 lg:place-self-center">
                <div class="flex">
                    <span class="text-center font-bold my-5 mx-auto">        
                        <a href="/" target="_blank" class="text-gray-800 font-bold text-2xl text-blue-600">
                            <span class="text-black">
                                FPV<br>
                                Платформа Онлайн-Курсов
                            </span>
                        </a>
                    </span>
                </div>
                <form class="mt-10" @submit.prevent="login">
                    <label for="username" class="block text-xs font-semibold text-gray-600 uppercase">Логин</label>
                    <input id="username" type="text" v-model="username" placeholder="Логин" required
                        class="block w-full py-3 px-1 mt-2 
                        text-gray-800 appearance-none 
                        border-b-2 border-gray-100
                        focus:text-gray-500 focus:outline-none focus:border-gray-200" />
                    <label for="password" class="block mt-2 text-xs font-semibold text-gray-600 uppercase">Пароль</label>
                    <div class="relative">
                        <input
                            id="password"
                            :type="showPassword ? 'text' : 'password'"
                            v-model="password"
                            placeholder="Пароль"
                            required
                            class="block w-full py-3 pl-1 pr-10 mt-2 mb-4
                            text-gray-800 appearance-none
                            border-b-2 border-gray-100
                            focus:text-gray-500 focus:outline-none focus:border-gray-200" />
                        <PasswordVisibilityToggle
                            :visible="showPassword"
                            @toggle="showPassword = !showPassword"
                        />
                    </div>
                    <button type="submit"
                        class="w-full py-3 mt-10 bg-gray-800 rounded-sm
                        font-medium text-white uppercase
                        focus:outline-none hover:bg-gray-700 hover:shadow-none">
                        Войти
                    </button>
                    <div class="sm:flex sm:flex-wrap mt-8 sm:mb-4 text-sm text-center">
                        <p @click.prevent="showRecoveryModal = true" class="flex-1 text-gray-500 text-left my-1 sm:my-auto underline">
                            Забыли пароль
                        </p>
                        <p class="flex-1 text-gray-500 text-md mx-4 my-1 sm:my-auto">
                            или
                        </p>
                        <router-link
                            :to="{ name: 'ClientRegister' }"
                            class="flex-2 underline">
                            Создать аккаунт
                        </router-link>
                    </div>
                </form>
                <p class="text-xs text-gray-500 mt-4 text-center">
                    Если вы забыли пароль, <router-link to="/client/feedback?from=/client/login" class="underline text-blue-600">обратитесь к модератору</router-link> или контактному лицу платформы для восстановления доступа к аккаунту
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { API_AUTH, HEADERS_JSON } from '@/const/uri';
import axios from 'axios';
import { mapActions, mapMutations } from 'vuex';
import PasswordRecoveryModal from "@/components/Auth/PasswordRecoveryModal.vue";
import PasswordVisibilityToggle from "@/components/Forms/PasswordVisibilityToggle.vue";

export default {
    components: {
        PasswordRecoveryModal,
        PasswordVisibilityToggle,
    },
    data() {
        return {
            labels: {
                login: 'Логин',
                password: 'Пароль',
            },
            username: '',
            password: '',
            showRecoveryModal: false,
            showPassword: false,
        }
    },
    methods: {
        ...mapActions(['toggleAlert']),
        ...mapMutations(['modalShow', 'createUser',]),
        getLabelEror(field_name) {
            return this.labels[field_name];
        },
        showErros(errors) {
            let allMessages = [];
            for (const key in errors) {
                var messages = typeof errors[key] == 'string' ? errors[key] : errors[key].join(', ');
                allMessages.push({
                'title': this.getLabelEror(key),
                'message': messages,
                });
            }
            this.modalShow({
                messages: allMessages,
                title: 'Проверьте данные формы',
                isError: true,
            });
        },
        async login() {
            if (this.username === "" || this.password === "") {
                this.toggleAlert({
                    message: "Пустые поля для ввода",
                    isError: true,
                });
                return false;
            }
            await axios({
                method: "POST",
                url: API_AUTH.clientLogin,
                data: {
                    login: this.username,
                    password: this.password,
                },
                headers: HEADERS_JSON,
            })
            .then((e) => {
                const data = e.data;
                const token = data.data.token;
                localStorage.setItem('user_token', token); 
                localStorage.setItem('user_token_expired', data.data.token_expired);
                this.createUser(data.data.user);
                this.$router.push({
                    name: 'ClientProfile',
                });
            })
            .catch((e) => {
                const data = (e.response && e.response.data) || {};
                const raw = data.error || data.errors || '';
                const text = typeof raw === 'string' ? raw : JSON.stringify(raw);
                if (text.includes('locked') || text.toLowerCase().includes('заблокирован')) {
                    this.toggleAlert({
                        message: 'Аккаунт заблокирован. Слишком много неудачных попыток входа. Обратитесь к модератору, чтобы получить доступ к платформе.',
                        isError: true,
                    });
                    return;
                }
                if (typeof raw === 'string' && raw) {
                    this.toggleAlert({ message: raw, isError: true });
                    return;
                }
                if (raw && typeof raw === 'object') {
                    const msg = Object.values(raw).map(v => Array.isArray(v) ? v.join(' ') : String(v)).join('; ');
                    this.toggleAlert({ message: msg || 'Ошибка входа', isError: true });
                    return;
                }
                this.toggleAlert({ message: 'Ошибка входа', isError: true });
            });
        },
    }, 
}
</script>

<style scoped>
.full-height-background {
    height: 100vh;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.login-form-container {
    width: 300px;
    padding: 20px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    margin-right: 50px;
}

.login-form-container form {
    display: flex;
    flex-direction: column;
}

.login-form-container input {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.button-container {
    display: flex;
    justify-content: space-between;
}

.login-form-container button {
    padding: 10px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: white;
    cursor: pointer;
}

.login-form-container button:hover {
    background-color: #0056b3;
}
</style>
